import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PWAPrompt from 'react-ios-pwa-prompt'
import { Box, Container, Typography, useMediaQuery, Avatar, Divider, Card, CardContent, Button, useTheme } from '@mui/material';

import Fb from 'components/Fb';
import Meta from 'components/Meta';
import useStyles from './styles';
import { auth } from '../../firebase';

function Welcome() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const classes = useStyles().classes;
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        navigate('/dashboard');
      }
    });

    return () => unsubscribe();
  }, [navigate]);

  const handleSignUpClick = () => {
    navigate('/login');
  };

  const renderContent = () => {
    if (isMobile) {
      return (
        <>
          <Typography className={classes.mobileAboutTextBold}>
            You’ve always heard that hard work leads to success. But it isn't enough.
          </Typography>
          <Typography className={classes.mobileAboutText}>
            Executives know a secret: Performance only makes up 10% of success. The real keys? <b>Image and Exposure.</b>
          </Typography>
          <Typography className={classes.mobileAboutText}>
            Start using Image and Exposure to land the promotions and dream jobs you deserve.
          </Typography>
          <Typography variant="h6" className={classes.mobileAboutTextBold}>
            Ready to level up your career?
          </Typography>
          <Button
            variant="contained"
            color="secondary"
            size="large"
            onClick={handleSignUpClick}
            className={classes.mobileSignUpButton}
          >
            Sign Up
          </Button>
        </>
      );
    } else {
      return (
        <>
          <Typography className={classes.aboutTextBold}>
            You've been told all your life that hard work leads to success, but what if there's more to the story?
          </Typography>
          <Typography className={classes.aboutText}>
            Imagine discovering the secret that top executives and successful leaders have used to fast-track their careers. Here's the truth: hard work alone—what we call "Performance"—accounts for just 10% of your success when it comes to landing that next big promotion or securing your dream job.
          </Typography>
          <Typography className={classes.aboutText}>
            The real game-changers? Image and Exposure. Together, they make up 90% of what it takes to rise through the ranks and land the opportunities you've always wanted.
          </Typography>
          <Typography className={classes.aboutText}>
            Unlock the strategies to elevate your career beyond hard work. Sign up today and start leveraging the power of Image and Exposure to secure the promotions and dream jobs you deserve.
          </Typography>
          <Typography variant="h6" sx={{ mt: 3, mb: 2 }}>
            Ready to take your career to the next level?
          </Typography>
          <Button
            variant="contained"
            color="secondary"
            size="large"
            onClick={handleSignUpClick}
            className={classes.signUpButton}
          >
            Sign Up Today
          </Button>
        </>
      );
    }
  };

  return (
    <>
      <Meta
        title="Welcome"
        description="Making your career development as easy as pie."
      />
      <PWAPrompt />
      <Box className={classes.contentWrapper}>
        <Container className={isMobile ? classes.mobileContainer : classes.container}>
          <Avatar 
            alt="PIE Career Icon" 
            src="/images/PIELogo.png"
            sx={{   
              width: 125, 
              height: 125, 
              margin: 'auto', 
              marginTop: isMobile ? 0 : -10
            }}
          />
          <Fb justifyCenter alignCenter>
            <Typography
                className={isMobile ? classes.mobileTitle : classes.title}
            >
              Making your next promotion as easy as pie.
            </Typography>
          </Fb>
        </Container>
      </Box>
      <Divider variant="middle" />
      <Box sx={{ px: isMobile ? 2 : 0 }}>
        <Container className={isMobile ? classes.mobileContainer : classes.container}>
          <Card sx={{ display: 'flex' }}>
            <CardContent sx={{ textAlign: 'center', pt: 4 }}>
              {renderContent()}
            </CardContent>
          </Card>
        </Container>
      </Box>
      <Box sx={{ position: 'fixed', bottom: 16, right: 16 }}>
        <Button
          variant="contained"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        >
          Back to top
        </Button>
      </Box>
    </>
  );
}

export default Welcome;